import { ElementRef, Renderer2, Directive, Input, HostBinding } from '@angular/core';
import { BootstrapColor } from '../../global-types';

@Directive({
  selector: '[bpListGroup], [bpLg]',
  exportAs: 'bpListGroup',
})
export class BpListGroupDirective {
  @HostBinding('class.list-group-flush') @Input() flush: boolean;
  @HostBinding('class.list-group-horizontal') @Input() horizontal: boolean;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.el.nativeElement, 'list-group');
  }
}

@Directive({
  selector: '[bpListGroupItem], [bpLgItem]',
  exportAs: 'bpListGroupItem',
})
export class BpListGroupItemDirective {
  @Input() active: boolean;
  @Input() disabled: boolean;
  @Input() action: boolean;
  @Input() color: BootstrapColor;


  @HostBinding('class') public get _class() {
    let cls = 'list-group-item';
    if (this.color) {
      cls += ` list-group-item-${this.color}`;
    }
    if (this.action) {
      cls += ' list-group-item-action';
    }
    if (this.disabled) {
      cls += ' disabled';
    }
    if (this.active) {
      cls += ' active';
    }

    return cls;
  }
}
